var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ContestDetails',{attrs:{"contest":_vm.contest,"user":_vm.user},on:{"participationCancelled":_vm.participationCancelled,"newParticipation":function($event){_vm.contest.userApplicationStatus = 'new'}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }